
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/[handle]",
      function () {
        return require("private-next-pages/blogs/[handle].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/[handle]"])
      });
    }
  